import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ProcessArtifactPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const ProcessArtifactResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.PROCESS_ARTIFACT).default(ResourceType.PROCESS_ARTIFACT),
    description: z.string(),
});
export const ProcessArtifactMutationResourceSchema = getMutationSchema(ProcessArtifactResourceSchema);

export type ProcessArtifactResource = z.infer<typeof ProcessArtifactResourceSchema>;

export const defaultProcessArtifactResource: ProcessArtifactResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.PROCESS_ARTIFACT,
    description: '',
};

export function useProcessArtifactActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-artifact',
            ResourceType.PROCESS_ARTIFACT,
            ProcessArtifactResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-artifact',
            ResourceType.PROCESS_ARTIFACT,
            ProcessArtifactResourceSchema
        ),
    };
}
